import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';
import ButtonScaleView from 'src/lib/ui/components/ButtonScaleView';
import { Feature } from 'src/replicant/analytics';
import {
  getLeagueLeaderboard,
  getVisibleLeagueLeaderboard,
} from '../../minigame/match2-timestep/leagues/league.sequences';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { createEmitter } from 'src/lib/Emitter';
import { canSeeLeague } from 'src/replicant/match2/leagues/leagues.getters';
import { leaderboardSize } from 'src/replicant/match2/leagues/leagues.ruleset';
import { RadialShine } from 'src/game/components/shared/RadialShine';

export class ChampionsLeagueTrophy extends ButtonScaleView {
  private rank: LangBitmapFontTextView;
  private rankFrame: ImageScaleView;
  private refreshCount = 0;

  constructor(opts: ViewOpts & { onClick?: () => Promise<void> }) {
    super({
      ...opts,
      width: 300,
      height: 300,
      pressedOffsetY: 5,
      centerOnOrigin: true,
      onClick: opts.onClick,
      tracking: {
        feature: Feature.LEAGUES._,
        $subFeature: Feature.LEAGUES.TROPHY,
      },
    });

    new RadialShine({
      superview: this,
      centerOnOrigin: true,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      scale: 2,
    });

    new ImageScaleView({
      superview: this,
      image: 'assets/ui/championsLeague/arena/trophy.png',
      scaleMethod: 'contain',
      width: downscale(341),
      height: downscale(452),
      centerOnOrigin: true,
      x: this.style.width * 0.5,
      y: this.style.width * 0.5,
    });

    this.rankFrame = new ImageScaleView({
      superview: this,
      width: downscale(169),
      height: downscale(113),
      x: this.style.width * 0.5,
      y: 130,
      centerOnOrigin: true,
      image: 'assets/ui/championsLeague/arena/flag_rank.png',
      visible: false,
    });

    this.rank = new LangBitmapFontTextView({
      superview: this.rankFrame,
      centerOnOrigin: true,
      align: 'center',
      verticalAlign: 'center',
      size: 40,
      font: 'Title',
      width: this.rankFrame.style.width - 20,
      height: this.rankFrame.style.height,
      x: this.rankFrame.style.width * 0.5 - 4,
      y: this.rankFrame.style.height * 0.5 - 9,
    });

    createEmitter(this, ({ user }) => ({
      canSee: canSeeLeague(user),
      leagues: getLeagueLeaderboard().getCached(),
    })).addListener(this.refresh);
  }

  private refresh = async (args: {
    canSee: boolean;
    leagues?: { playerRank: number };
  }) => {
    const refreshId = ++this.refreshCount;
    const { canSee } = args;

    const leagues = await getVisibleLeagueLeaderboard(canSee);
    if (refreshId !== this.refreshCount) return;

    const showRank = !!(
      canSee &&
      leagues &&
      leagues.playerRank <= leaderboardSize
    );
    this.rankFrame.updateOpts({
      visible: showRank,
    });

    if (!showRank) return;

    this.rank.localeText = () =>
      leagues.playerRank <= leaderboardSize
        ? `${leagues!.playerRank.toString()}`
        : '-';
  };
}
